$(document).ready(function () {
  const Event = function (data) {
    const self = this;
    // fields: imagesrc, imagealt, isOpenForRegistration, privateClass, registrationLink, type, eventTitle, namelink, eventDate, displayEventDate, city, state, location, totalParticipants, totalDonations
    ko.mapping.fromJS(data, {}, this);

    if (this.isOpenForRegistration()) {
      this.actions = [
        { html: '<a href="' + this.registrationLink() + '" class="button success' + this.privateClass() + '">Join</a>' }
      ];
    } else {
      this.actions = [
        { html: '<div class="registration-closed">Closed</div>' }
      ];
    }

    this.meta = [
      {
        attr: 'date',
        listitemclass: '',
        iconclass: 'icon-calendar',
        text: this.displayEventDate
      },
      {
        attr: 'location',
        listitemclass: '',
        iconclass: 'icon-pushpin',
        text: this.location
      },
      {
        attr: 'total-participants',
        listitemclass: '',
        iconclass: 'icon-medal',
        text: this.totalParticipants
      },
      {
        attr: 'amount-raised',
        listitemclass: '',
        iconclass: 'icon-money',
        text: this.totalDonations
      }
    ];

    this.entitycardclass = 'entity-card';
    this.nameclass = 'name';
  };

  const PartnerEventViewModel = function () {
    const self = this;

    this.events = ko.observableArray();
    this.chunkedEvents = ko.observableArray();

    this.updateResults = function (input) {
      const results = ko.utils.arrayMap(input, function (item) {
        return new Event(item);
      });

      self.events(results);
      if (self.order() == 'reverse') {
        self.events.reverse();
      }

      self.sortResults();
      self.chunkEvents();
    };

    this.chunkEvents = function () {
      this.chunkedEvents([]);
      let i; let j; const chunk = 2;
      for (i = 0, j = self.events().length; i < j; i += chunk) {
        self.chunkedEvents.push(self.events().slice(i, i + chunk));
      }
    };

    this.reverseResults = function (e) {
      const order = self.order() == 'normal' ? 'reverse' : 'normal';
      self.order(order);
      self.events.reverse();
      self.chunkEvents();

      privateEventSetupDisplay();
    };

    this.sortResults = function (e) {
      if (self.sortBy()) {
        const sortBy = self.sortBy();
        let sortFunction;

        if (sortBy == 'donation') {
          sortFunction = function (left, right) {
            const leftValue = parseFloat(left.totalDonations().replace(/[$,]+/g, ''));
            const rightValue = parseFloat(right.totalDonations().replace(/[$,]+/g, ''));
            return leftValue == rightValue ? 0 : (leftValue < rightValue ? 1 : -1);
          };
        }

        if (sortBy == 'participant') {
          sortFunction = function (left, right) {
            const leftValue = parseInt(left.totalParticipants());
            const rightValue = parseInt(right.totalParticipants());
            return leftValue == rightValue ? 0 : (leftValue < rightValue ? 1 : -1);
          };
        }

        if (sortBy == 'event_title') {
          sortFunction = function (left, right) {
            const leftValue = $.trim(left.eventTitle().toLowerCase());
            const rightValue = $.trim(right.eventTitle().toLowerCase());
            return leftValue == rightValue ? 0 : (leftValue < rightValue ? -1 : 1);
          };
        }

        if (sortBy == 'city') {
          sortFunction = function (left, right) {
            const leftValue = $.trim(left.city().toLowerCase());
            const rightValue = $.trim(right.city().toLowerCase());
            return leftValue == rightValue ? 0 : (leftValue < rightValue ? -1 : 1);
          };
        }

        if (sortBy == 'state') {
          sortFunction = function (left, right) {
            const leftValue = $.trim(left.state().toLowerCase());
            const rightValue = $.trim(right.state().toLowerCase());
            return leftValue == rightValue ? 0 : (leftValue < rightValue ? -1 : 1);
          };
        }

        if (sortBy == 'date') {
          sortFunction = function (left, right) {
            const leftValue = $.trim(left.eventDate().toLowerCase());
            const rightValue = $.trim(right.eventDate().toLowerCase());
            return leftValue == rightValue ? 0 : (leftValue < rightValue ? -1 : 1);
          };
        }

        self.events.sort(sortFunction);
        if (self.order() == 'reverse') {
          self.events.reverse();
        }

        self.chunkEvents();

        privateEventSetupDisplay();
      }
    };

    this.sortBy = ko.observable('donation');
    this.order = ko.observable('normal');

    this.eventData = $.parseJSON($('#all-events-json').html());
    this.stateSortTerm = $('#state-sort-term').text();

    this.updateResults(this.eventData);

    this.sortOptions = ko.observableArray([
      { text: 'Donation Amount', value: 'donation' },
      { text: 'Participant Count', value: 'participant' },
      { text: 'Event Title', value: 'event_title' },
      { text: 'City', value: 'city' },
      { text: self.stateSortTerm, value: 'state' },
      { text: 'Event Date', value: 'date' }
    ]);
  };

  window.pageVM = new PartnerEventViewModel();
  ko.applyBindings(window.pageVM, document.getElementById('partner-events'));
});

// Workaround for showing the private event label and tooltip.
window.setTimeout(function () {
  privateEventSetupDisplay();
}, 100);

const privateEventSetupDisplay = () => {
  $('#partner-events a.private-event').each(function () {
    const $card = $(this).closest('.entity-card');
    $card.find('.private-event-label').prev('.type').hide();
    $('<br/>').insertAfter(
      $card.find('.private-event-label')
        .html('PRIVATE')
        .css('display', 'inline-block')
        .next('span.private-event-tooltip-button')
        .css('display', 'inline-block')
    );
    privateEventToolTipButtonsAssignEventHandlers();
  });
};

/**
 * Assign event handlers for private event tooltip buttons.
 *
 * @return    none
 */
const privateEventToolTipButtonsAssignEventHandlers = () => {
  $('.private-event-tooltip-button').each(function () {
    privateEventTooltipButtonAssignEventHandlers($(this));
  });
};

/**
 * Assign event handlers for private event tooltip button.
 *
 * @param     object    $button    A jquery wrapped HTML element.
 * @return    none
 */
const privateEventTooltipButtonAssignEventHandlers = ($button) => {
  // Button - mouse enter event.
  $button.unbind('mouseenter').bind('mouseenter', function () {
    const $this = $(this);
    const $popup = $('.private-event-tooltip-popoup');
    if ($popup.length) {
      const buttonOffset = $this.offset();
      const buttonHeight = $this.height();
      const popupWidth = $popup.width();
      const popupHeight = $popup.height();
      const popupPadding = parseInt($popup.css('padding'));
      $popup.css({
        display: 'block',
        top: buttonOffset.top - popupHeight - (popupPadding * 2) - buttonHeight,
        left: buttonOffset.left - parseInt(popupWidth / 2)
      });
    }
  });
  // Button - mouse leave event.
  $button.unbind('mouseleave').bind('mouseleave', function () {
    $('.private-event-tooltip-popoup').css('display', 'none');
  });
};
